import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RecurringPaymentPlanPage } from './recurring-payment-plan.page';

const routes: Routes = [
  {
    path: '',
    component: RecurringPaymentPlanPage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class RecurringPaymentPlanPageRoutingModule {}
